import apiService from "../../api/api.service";
import {
  OrdersResponse,
  OrderDetailResponse,
  OrderSummaryResponse,
  CancelInfoResponse,
  CancelOrderResponse,
  ReorderResponse,
  ReturnInfoResponse,
  ReturnPreviewResponse,
  ReturnOrderResponse,
  GetOrdersRequest,
  GetOrderSummaryRequest,
  CancelOrderRequest,
  ReorderRequest,
  ReturnPreviewRequest,
  ReturnOrderRequest,
} from "./orders.types";

/**
 * Get orders list
 */
export const fetchOrders = (params?: GetOrdersRequest) => {
  return apiService.get<OrdersResponse>("/orders", { params });
};

/**
 * Get order summary (statuses and dates)
 */
export const fetchOrderSummary = (params?: GetOrderSummaryRequest) => {
  return apiService.get<OrderSummaryResponse>("/orders/summary", { params });
};

/**
 * Get order detail by order number
 */
export const fetchOrderDetail = (orderNumber: string) => {
  return apiService.get<OrderDetailResponse>(`/orders/${orderNumber}`);
};

/**
 * Get cancel info (includes reasons and products)
 */
export const fetchCancelInfo = (orderNumber: string) => {
  return apiService.get<CancelInfoResponse>(`/orders/${orderNumber}/cancel-info`);
};

/**
 * Cancel order
 */
export const cancelOrder = (orderNumber: string, data?: CancelOrderRequest) => {
  return apiService.post<CancelOrderResponse>(
    `/orders/${orderNumber}/cancel`,
    data
  );
};

/**
 * Reorder (add items to cart again)
 */
export const reorder = (orderNumber: string, params?: ReorderRequest) => {
  return apiService.post<ReorderResponse>(
    `/orders/${orderNumber}/reorder`,
    undefined,
    { params }
  );
};

/**
 * Get return info (includes reasons and products)
 */
export const fetchReturnInfo = (orderNumber: string) => {
  return apiService.get<ReturnInfoResponse>(`/orders/${orderNumber}/return-info`);
};

/**
 * Return preview
 */
export const returnPreview = (orderNumber: string, data: ReturnPreviewRequest) => {
  return apiService.post<ReturnPreviewResponse>(
    `/orders/${orderNumber}/return-preview`,
    data
  );
};

/**
 * Return order
 */
export const returnOrder = (orderNumber: string, data: ReturnOrderRequest) => {
  return apiService.post<ReturnOrderResponse>(
    `/orders/${orderNumber}/return`,
    data
  );
};